export const GOODS_SEARCH_FIELDS = [
  { value: 'contentName', label: '名称', placeholder: '请输入商品名称' },
  { value: 'goodsId', label: '商品ID', placeholder: '请输入商品ID' },
  { value: 'uniqueCode', label: '商品唯一编码', placeholder: '请输入商品唯一编码' },
  { value: 'skuCode', label: '规格编码', placeholder: '请输入规格编码' },
  { value: 'giftsCode', label: '赠品编码', placeholder: '请输入赠品编码' }
]

export function goodsSearchParams(search) {
  const field = GOODS_SEARCH_FIELDS.find(item => item.value === search.matchField)
  return field ? { [field.value]: search.keyword.trim() } : {}
}

export const GOODS_SEARCH_TYPES = [
  { value: 3, label: '专栏', listPath: '/shop/packageColumn/list', detailPath: '/shop/packageColumn/columnDetail' },
  { value: 4, label: '大专栏', listPath: '/shop/packageCollegeColumn/list', detailPath: '/shop/packageCollegeColumn/collegeColumnDetail' },
  { value: 5, label: '线下课', listPath: '/shop/offline/list', detailPath: '/shop/offline/offlineDetail' },
  { value: 7, label: '套餐课', listPath: '/shop/package/list', detailPath: '/shop/package/detail' },
  { value: 8, label: '训练营', listPath: '/shop/liveCourse/list', detailPath: '/shop/liveCourse/detail' }
]

export function findGoodsRoute(routes, target, base = '') {
  for (const route of routes || []) {
    const path = route.path.startsWith('/') ? route.path : `${base}/${route.path}`
    if (path.toLowerCase() === target.toLowerCase()) return route
    const found = findGoodsRoute(route.children, target, path)
    if (found) return found
  }
}

export function canEditGoods(routes, goodsType) {
  const type = GOODS_SEARCH_TYPES.find(item => item.value === Number(goodsType))
  const route = type && findGoodsRoute(routes, type.listPath)
  return !!(route && route.meta && (route.meta.permsList || []).includes('system:goods:edit'))
}

// 五类列表共用同一组关键词参数，保留各列表的其他筛选及分页逻辑。
export const goodsListSearchMixin = {
  data() {
    return { goodsSearch: { matchField: 'contentName', keyword: '' } }
  },
  computed: {
    goodsSearchParams() {
      return goodsSearchParams(this.goodsSearch)
    }
  },
  methods: {
    resetGoodsSearch() {
      this.goodsSearch = { matchField: 'contentName', keyword: '' }
    }
  }
}

// 详情页沿用原有编辑组件；新页签携带 edit=1 时直接展开编辑。
export const goodsSearchEditMixin = {
  watch: {
    'detail.goodsId': 'openGoodsSearchEdit',
    '$route.query.edit': 'openGoodsSearchEdit'
  },
  methods: {
    openGoodsSearchEdit() {
      if (this.$route.query.edit !== '1' || !this.detail.goodsId) return
      if (String(this.detail.goodsId) !== String(this.$route.params.id)) return
      if (!canEditGoods(this.$store.getters.permission_routes, this.detail.goodsType)) return
      this.gotoEdit(this.detail)
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, edit: undefined }
      })
    }
  }
}
